import defaultSettings from '../settings.json';
import { storageSetItem } from '@/utils/storage';
import { formatEnum, getStoredUserInfo, normalizeUserInfo } from './utils';
const initialUserInfo = normalizeUserInfo(getStoredUserInfo());
const initialState = {
  settings: defaultSettings,
  appConfig: {},
  companyId: initialUserInfo.compId || '1',
  companyName: '码上视界科技有限公司',
  dicts: formatEnum([]),
  userInfo: initialUserInfo
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return {
          ...state,
          settings
        };
      }
    case 'update-pagePermissionCodes':
      {
        const {
          pagePermissionCodes
        } = action.payload || {};
        return {
          ...state,
          pagePermissionCodes: pagePermissionCodes ?? state.pagePermissionCodes
        };
      }
    case 'update-menuKeys':
      {
        const {
          menuKeys
        } = action.payload || {};
        return {
          ...state,
          menuKeys: menuKeys ?? state.menuKeys
        };
      }
    case 'update-appConfig':
      {
        const {
          appConfig
        } = action.payload;
        return {
          ...state,
          appConfig
        };
      }
    case 'update-companyId':
      {
        const {
          companyId
        } = action.payload || {};
        return {
          ...state,
          companyId: companyId || state.companyId || initialState.companyId
        };
      }
    case 'update-dicts':
      {
        const {
          dicts
        } = action.payload || {};
        return {
          ...state,
          dicts: formatEnum(dicts)
        };
      }
    case 'update-userInfo':
      {
        const payload = action.payload || {};
        const nextUserLoading = payload.userLoading === undefined ? state.userLoading : payload.userLoading;
        if (payload.userInfo !== undefined) {
          storageSetItem('user', payload.userInfo);
        }
        const nextUserInfo = normalizeUserInfo(payload.userInfo ?? getStoredUserInfo() ?? state.userInfo ?? initialState.userInfo);
        return {
          ...state,
          companyId: payload.companyId ?? nextUserInfo.compId ?? state.companyId,
          userLoading: nextUserLoading,
          userInfo: nextUserInfo
        };
      }
    default:
      return state;
  }
}